###
# tablePreviewSampling
# =====================
# This factory provides a function called 'decide' which is responsible
# for making decisions about how to get data from the various services in
# this directive. It will return an instance of the Decisions class,
# which contains a list of columns and the decision that has been made
# for the column. A "decision" is a map of the form:
#
# {column: X
#  action: Y}
#
# where "action" can be: "sample", "calculate", or "failed". The "sample"
# columns are those that can be sampled directly from the serving layer.
# The "calculate" columns are those that can be calculated within the
# derivative service. And the "failed" columns cannot be handled since we
# cannot get data for them in any way.
#
# Later, this can be extended so that columns with the "sample" action
# can have extra data attached to them. When we are sampling columns from
# foreign tables, we want to limit the sampling to specific rows. We can do
# this by specifying the foreign key relationships within the "decision"
# so that we later know how to actually do the sampling.
###
angular.module('rjmNg.services').factory 'tablePreviewSampling', [
  "Columns"
  '$q'
  'dataSampleService'
  'FilterSets'
  (Columns, $q, dataSampleService, FilterSets) ->
    class Decisions
      constructor: (subDecisions = []) ->
        @_decisions = {}
        @merge d for d in subDecisions
      add: (decision) ->
        @_decisions[decision.column.id] = decision
      merge: (decisions) ->
        for k, v of decisions._decisions
          @_decisions[k] = v
      _getAll: ->
        (d for k, d of @_decisions)
      _getColumnsByAction: (action) ->
        (d.column for k, d of @_decisions when d.action == action)
      getActionByColumnId: (columnId) ->
        (d.action for k, d of @_decisions when d.column.id == columnId)[0]
      getColumnsToSample: () ->
        @_getColumnsByAction "sample"
      getColumnsToCalculate: () ->
        @_getColumnsByAction "calculate"
      getFailedColumns: () ->
        @_getColumnsByAction "failed"
      getAllForTable: (tableId) ->
        ds = new Decisions()
        ds.add d for d in @_getAll() when d.column.table_id == tableId
        return ds

    service = {}

    _decideForTree = (tree) ->
      decisions = new Decisions()
      column = tree.column
      action = "failed"
      if column.is_in_serving_layer and column.id isnt 0
        action = "sample"
      columnDecision = {column: column, action: action}
      decisions.add columnDecision
      return decisions

    service.decide = (columns) ->
      deferred = $q.defer()
      decisions = new Decisions()
      for column in columns
        decisions.add
          column: column
          action: if column.is_in_serving_layer then "sample" else "failed"
      deferred.resolve decisions

      return deferred.promise

    getSavedFilterSetIds = (columns) ->
      filterSetIds = []
      for column in columns
        filters = column.properties?.filter_set?.filters
        if !_.isUndefined(filters) && filters?.length > 0
          for filter in filters
            if !_.isUndefined(filter.filter_set_id)
              filterSetIds.push filter.filter_set_id
      return filterSetIds

    service.getAllData = (decisions, canceller, force=false) ->
      deferred = $q.defer()
      dataSampleService.multiTableSample(decisions.getColumnsToSample(), canceller, force)
      .then (sampledData) ->
        deferred.resolve
          sampledData: sampledData
          calculatedData: sampledData
      .catch (e) ->
          deferred.reject
            error: e
            sampledData: null
      return deferred.promise

    return service
]
